import moment from "moment";
import { useContext, useEffect, useState } from "react";
import TabComponent from "../../TabsComponent";
import styles from "./styles.module.scss";
import NotesManager from "../../../Managers/Users/Notes";
import LoaderImg from "../../../assets/images/Loader.gif";
import trashImg from "../../../assets/images/trash.png";
import { UserContext } from "../../../contexts/UserContext/UserContextProvider";
import { scrollToBottom, secondsToHms } from "../../../utils/common.utils";
import { AnalyticsContext } from "../../../contexts/Analytics/AnalyticsContextProvider";
import { NOTE_CREATED_EVENT } from "../../../Clevertap/EventNames.ts";
import { getNoteData } from "../../../Clevertap/EventHandler.ts";

const Notes = ({
  targetType,
  content,
  allNotes,
  videoId,
  muxVideoRef,
  user,
}) => {
  const [noteText, setNoteText] = useState("");
  const { addCleverTapAnalytics } = useContext(AnalyticsContext);

  useEffect(() => {
    scrollToBottom("notes-Container");
  }, []);

  const handleInput = async (e) => {
    e.preventDefault();

    if (!muxVideoRef || !noteText.trim()) {
      return;
    }

    let pos = {
      targetId: videoId,
      noteContent: noteText,
      userId: user.uid,
      startTime: muxVideoRef.current.currentTime,
      endTime: muxVideoRef.current.currentTime,
    };
    addCleverTapAnalytics(
      NOTE_CREATED_EVENT,
      getNoteData({
        "Start Time": pos["startTime"],
        "End Time": pos["endTime"],
        Note: pos["noteContent"],
        targetType: targetType,
        ...content,
      })
    );
    await NotesManager._post.createNote(pos);
    setTimeout(() => {
      scrollToBottom("notes-Container");
    }, 300);
    setNoteText("");
  };

  const handleTimeFrameClick = (startTime) => {
    if (muxVideoRef) {
      muxVideoRef.current.currentTime = startTime;
      muxVideoRef.current.paused && muxVideoRef.current.play();
    }
  };

  const handleDeleteBtn = async (index) => {
    let obj = { targetId: videoId, userId: user.uid, index: index };

    await NotesManager._delete.deleteNote(obj);
  };

  return (
    <div className={styles.notesContainer}>
      <div id="notes-Container" className={styles.notesWrapper}>
        {!allNotes && (
          <div className={styles.loader}>
            <img src={LoaderImg} alt="loading..." />
          </div>
        )}
        {/* {allNotes &&
          allNotes.content && allNotes.content.length === 0 && (
            <div className={styles.noVisiblePoll}>
              As soon as a poll is posted <br></br>you will be able to express
              your opinion.
            </div>
          )} */}
        {allNotes &&
          allNotes.content &&
          allNotes.content.length !== 0 &&
          allNotes.content.map(({ id, note, startTime }, index) => {
            return (
              <div key={id} className={styles.noteBox}>
                <div
                  onClick={() => handleTimeFrameClick(startTime)}
                  className={styles.timeStamp}
                >
                  {/* {startTime} */}
                  {startTime && startTime == 0
                    ? "0:00"
                    : moment("2015-01-01")
                        .startOf("day")
                        .seconds(startTime)
                        .format("H:mm:ss")}
                </div>
                <div>{note}</div>
                <div className={styles.actionBtns}>
                  <div
                    className={styles.deleteBtn}
                    onClick={() => handleDeleteBtn(index)}
                  >
                    <img src={trashImg} alt="Delete" />
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <form className={styles.input} onSubmit={handleInput}>
        <input
          id="inputBox"
          type="text"
          placeholder="Add your note"
          value={noteText}
          onChange={(e) => {
            setNoteText(e.target.value);
          }}
          autoComplete="off"
        />
        <button className="btn" disabled={!noteText.length}>
          Add
        </button>
      </form>
    </div>
  );
};

const Transcript = ({ allChapters, seekTo }) => {
  return (
    <div className={`${styles.notesWrapper} ${styles.chaptersWrapper}`}>
      {allChapters.map((note, index) => {
        return (
          <div key={index} className={styles.transcriptBox}>
            <div
              onClick={() => {
                seekTo(note.startTime);
              }}
              className={styles.timeStamp}
            >
              {secondsToHms(note.startTime)}
            </div>
            <div>{note.title}</div>
          </div>
        );
      })}
    </div>
  );
};

function NewsAndTranscript({
  targetType,
  content,
  allNotes,
  allChapters,
  videoId,
  muxVideoRef,
  seekTo,
}) {
  const { user } = useContext(UserContext);

  const TABS = [
    {
      label: "My Notes",
      childComponent: () => {
        return (
          <Notes
            targetType={targetType}
            content={content}
            allNotes={allNotes}
            videoId={videoId}
            muxVideoRef={muxVideoRef}
            user={user}
          />
        );
      },
      hideTab: false,
    },
    {
      label: "Chapters",
      // label: "Transcript",
      childComponent: () => {
        return <Transcript allChapters={allChapters} seekTo={seekTo} />;
      },
      hideTab: true, // !allChapters || false,
    },
  ];
  const [selectedTab, setSelectedTab] = useState(0);
  return (
    <TabComponent
      tabs={TABS}
      onChangeTab={(index) => {
        setSelectedTab(index);
      }}
      activeTab={selectedTab}
      customHeaderClass={styles.customTabHeader}
      customTabClass={styles.customTabClass}
      customTabContent={`${
        selectedTab === 1
          ? styles.customTabContentChapters
          : styles.customTabContent
      }`}
    />
  );
}

export default NewsAndTranscript;
